import React, { useState, useEffect } from "react";
import "./SendPeport.css";
import useMonthlyAccess from "../../Hooks/useMonthlyAccess";
import { useAuth } from "../../AuthContext";
import { useNavigate } from "react-router-dom";
import useCurrentList from "../../Hooks/useCurrentList";
import useWeeklyDietPlans from "../../Hooks/useWeeklyDietPlans";

export default function SendReport({ from, onShowAlert }) {
  const navigate = useNavigate();
  const { userToken } = useAuth();
  const { plans } = useCurrentList(userToken);
  const { exercises, diets } = useMonthlyAccess(userToken);
  const { weeklyDietReports } = useWeeklyDietPlans(userToken);
  const [showOptions, setShowOptions] = useState(false);
  const [isCalendarLock, setIsCalendarLock] = useState(true);
  const [isFoodLock, setIsFoodLock] = useState(true);
  const [isExerciseLock, setIsExerciseLock] = useState(true);

  useEffect(() => {
    if (diets.length > 0 || exercises.length > 0) {
      setIsCalendarLock(false);
    }
  }, [diets, exercises]);

  useEffect(() => {
    if (plans !== null && plans.length > 0) {
      setIsExerciseLock(false);
    }
  }, [plans]);

  useEffect(() => {
    if (weeklyDietReports && weeklyDietReports.length > 0) {
      setIsFoodLock(false);
    }
  }, [weeklyDietReports]);

  const handleShowOptions = () => {
    setShowOptions(!showOptions);
  };

  const openMonthlyReport = () => {
    if (!isCalendarLock) {
      navigate("/monthlyReport");
    } else {
      onShowAlert();
    }
  };

  const openClassFeedBack = () => {
    if (isExerciseLock) {
      onShowAlert();
    } else {
      navigate("/classFeedback", { state: { plans: plans } });
    }
  };

  const openDietReport = () => {
    if (isFoodLock) {
      onShowAlert();
    } else {
      navigate("/nutritionFeedback");
    }
  };

  return (
    <div className="sendReportWrapper">
      <div className="sendReportInner centeredFlex" onClick={handleShowOptions}>
        <div className="sendReport centeredFlex">
          <img
            src="/images/report.svg"
            alt="report icon"
            className="reportIcon"
          />
          <div className="plusWrapper centeredFlex">
            <span>+</span>
          </div>
        </div>
        <span className="sendReportText">ارسال گزارشات</span>
      </div>
      <div
        className={`sendReportOptions centeredFlex ${
          showOptions ? "showReportOptions" : ""
        }`}
        style={
          from === "userPanel"
            ? {
                flexDirection: "column",
                left: "110%",
                transform: "translateY(-50%)",
              }
            : {
                flexDirection: "row",
                left: "95%",
                transform: "translateY(-70%)",
              }
        }
      >
        <div
          className="sendReportItem centeredFlex"
          onClick={openMonthlyReport}
        >
          <img
            src={
              isCalendarLock
                ? "/images/ic_calendar_alpha1.svg"
                : "/images/ic_calendar_alpha2.svg"
            }
            alt="calendar"
          />
        </div>
        <div className="sendReportItem centeredFlex" onClick={openDietReport}>
          <img
            src={
              isFoodLock
                ? "/images/ic_food_alpha1.svg"
                : "/images/ic_food_alpha2.svg"
            }
            alt="food"
          />
        </div>
        <div
          className="sendReportItem centeredFlex"
          onClick={openClassFeedBack}
        >
          <img
            src={
              isExerciseLock
                ? "/images/ic_exercise_alpha1.svg"
                : "/images/ic_exercise_alpha2.svg"
            }
            alt="weight"
          />
        </div>
      </div>
    </div>
  );
}
